import { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios'

export const getAssumeToken = () => sessionStorage.getItem('assume_token')
export const setAssumeToken = (token: string) => sessionStorage.setItem('assume_token', token)
export const removeAssumeToken = () => sessionStorage.removeItem('assume_token')

export const getToken = () => localStorage.getItem('token')
export const getTokenTwoFa = () => localStorage.getItem('token-2fa')

export const getParserToken = () => {
  const tokenAll = getAssumeToken() || getToken()

  if (!tokenAll) return null

  try {
    const [, tokenData] = tokenAll.split('.')

    return JSON.parse(atob(tokenData))
  } catch (e) {
    return null
  }
}

export const setToken = (token: string) => {
  localStorage.setItem('token', token)
}
export const removeToken = () => {
  localStorage.removeItem('token')
}

export const removeTokenTwoFa = () => {
  localStorage.removeItem('token-2fa')
}

export const setTokenHeaderFromViaConfig = (axiosConfig: InternalAxiosRequestConfig) => {
  const isAdminRequest = axiosConfig.meta?.adminRequest === true
  const isTwoFa = axiosConfig.tokenType === '2fa'
  const token = isAdminRequest ? getToken() : getAssumeToken() || getToken()

  if (isTwoFa) {
    axiosConfig.headers.authorization = `Bearer ${getTokenTwoFa()}`
  } else if (token) {
    axiosConfig.headers.authorization = `Bearer ${token}`
  }
}

export const setTokenLocalStorageViaConfig = (axiosConfig: AxiosResponse, isAssume: boolean) => {
  const config = axiosConfig?.config
  const url = config?.url
  const data = axiosConfig?.data

  if (url?.includes('auth/register/secondary')) {
    const token = data.token

    setTokenLocalStorage(token.access_token, isAssume)
  }

  if (url?.includes('2fa/auth/login') || (url?.includes('auth/switch') && data?.switched)) {
    const token = data.token
    const is_2fa = data.data?.is_2fa

    if (is_2fa) {
      setTokenLocalTwoFaStorage(token.access_token)
    } else {
      setTokenLocalStorage(token.access_token, isAssume)
    }
  }

  if (url?.includes('auth/refresh')) {
    const isLogin = data.is_login

    removeTokenTwoFa()

    if (isLogin === true) {
      const token = data.token

      setTokenLocalStorage(token.access_token, isAssume)
    }
  }
}

export const setTokenLocalTwoFaStorage = (token: string) => {
  if (token) {
    localStorage.setItem('token-2fa', token)
  }
}

export const setTokenLocalStorage = (token: string, isAssume: boolean) => {
  if (token) {
    if (isAssume) {
      setAssumeToken(token)
    } else {
      setToken(token)
    }
  }
}

export const removeTokenLocalStorage = (isAssume: boolean) => {
  if (isAssume) {
    removeAssumeToken()
  } else {
    removeToken()
  }
}
